<template>
  <div v-if="rendered">
    <base-header class="pb-6">
      <b-row aling-v="center" class="py-4">
        <b-col xl="8">
          <h6 class="h2 d-inline-block mb-0">Dashboard</h6>
        </b-col>
        <b-col xl="2">
          <el-select
            v-model="restaurantesSelecionados"
            multiple
            filterable
            placeholder="Restaurantes (Todos)"
            @change="mudarDatas"
          >
            <el-option
              v-for="option in restaurantes"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
        </b-col>
        <b-col xl="2">
          <base-input>
            <flat-picker
              slot-scope="{ focus }"
              @on-open="focus"
              @on-close="mudarDatas"
              :config="datepickerConfig"
              class="form-control datepicker"
              v-model="dates.range"
            />
          </base-input>
        </b-col>
        <!-- <b-col cols="5" lg="6" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6 content">
      <b-row class="pb-3">
        <b-col xl="4">
          <h1 class="text-black text-500">Sobre Cartões</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Cartões Emitidos</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ dadosDashboard.cartoes_emitidos }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.cartoes_emitidos,
                    dadosDashboard.cartoes_emitidos_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.cartoes_emitidos,
                    dadosDashboard.cartoes_emitidos_prev
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Visitas Únicas</h3>
            <b-row class="px-3">
              <h2 class="numberResult">{{ dadosDashboard.clientes_ativos }}</h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.clientes_ativos,
                    dadosDashboard.clientes_ativos_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.clientes_ativos,
                    dadosDashboard.clientes_ativos_prev
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Visitas</h3>
            <b-row class="px-3">
              <h2 class="numberResult">{{ dadosDashboard.visitas_total }}</h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.visitas_total,
                    dadosDashboard.visitas_total_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.visitas_total,
                    dadosDashboard.visitas_total_prev
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col xl="4">
          <h1 class="text-black text-500">Sobre Refeições</h1>
        </b-col>
      </b-row>
      <b-row class="pink-solid">
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Refeições Realizadas</h3>
            <b-row class="px-3">
              <h2 class="numberResult">{{ dadosDashboard.visitas_total }}</h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.visitas_total,
                    dadosDashboard.visitas_total_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.visitas_total,
                    dadosDashboard.visitas_total_prev
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Ticket Médio</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ formatarEuro(dadosDashboard.ticket_medio.toFixed(2)) }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.ticket_medio,
                    dadosDashboard.ticket_medio_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.ticket_medio,
                    dadosDashboard.ticket_medio_prev,
                    "euro"
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Faturação Total</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ formatarEuro(dadosDashboard.faturacao_total) }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p
                :class="
                  classeDiferenca(
                    dadosDashboard.faturacao_total,
                    dadosDashboard.faturacao_total_prev
                  )
                "
              >
                {{
                  diferenca(
                    dadosDashboard.faturacao_total,
                    dadosDashboard.faturacao_total_prev,
                    "euro"
                  )
                }}
              </p>
            </b-row>
          </card>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col xl="4">
          <h1 class="text-black text-500">Sobre Clientes</h1>
        </b-col>
      </b-row>
      <b-row class="pink-transparent">
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Clientes Assíduos</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ dadosDashboard.clientes_assiduos }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p class="link text-underline pointer">Ver Clientes</p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Clientes Frequentes</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ dadosDashboard.clientes_frequentes }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p class="link text-underline pointer">Ver Clientes</p>
            </b-row>
          </card>
        </b-col>
        <b-col xl="4">
          <card class="no-border-card">
            <h3>Clientes Ocasionais</h3>
            <b-row class="px-3">
              <h2 class="numberResult">
                {{ dadosDashboard.clientes_ocasionais }}
              </h2>
            </b-row>
            <b-row class="px-3">
              <p class="link text-underline pointer">Ver Clientes</p>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <LoadingOverlay v-else />
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

// Lists
import ActivityFeed from "./ActivityFeed";
import TaskList from "./TaskList";
import UserList from "./UserList";
import ProgressTrackList from "./ProgressTrackList";

// Tables
import LightTable from "./LightTable";
import SocialTrafficTable from "./SocialTrafficTable";
import PageVisitsTable from "./PageVisitsTable";

import flatPicker from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import "flatpickr/dist/flatpickr.css";

import LoadingOverlay from "@/components/Loading/LoadingOverlay";
import axios from "axios";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
  components: {
    ActivityFeed,
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingOverlay,
    flatPicker,
    LineChart,
    BarChart,
    BaseProgress,
    RouteBreadCrumb,
    StatsCard,
    TaskList,
    PageVisitsTable,
    SocialTrafficTable,
    LightTable,
    UserList,
    ProgressTrackList,
  },
  data() {
    return {
      restaurantes: [],
      restaurantesSelecionados: [],
      dadosDashboard: [],
      rendered: false,
      dates: {
        range: "",
      },
      datepickerConfig: {
        mode: "range",
        locale: Portuguese,
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Y-m-d", // este é o que vai para v-model
      },
    };
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async inicio() {
      this.rendered = false;

      const dadosGuardados = localStorage.getItem("dashboardDatas");

      let start,
        end,
        restaurantes = [];

      if (dadosGuardados) {
        const parsed = JSON.parse(dadosGuardados);
        start = parsed.start;
        end = parsed.end;
        restaurantes = parsed.restaurantes || [];
        this.dates.range = `${start} até ${end}`;
        this.restaurantesSelecionados = restaurantes;
      } else {
        const today = new Date();
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - 90);

        start = this.formatDate(pastDate);
        end = this.formatDate(today);
        this.dates.range = `${start} até ${end}`;
      }

      try {
        const token = localStorage.getItem("tokenAbitue");

        const response = await axios.post(
          "http://localhost:3001/api/cartoes/dashboard-resumo",
          {
            start,
            end,
            restaurantesSelecionados: this.restaurantesSelecionados,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.dadosDashboard = response.data;
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao obter resumo do dashboard:", err);
        }
      }

      this.rendered = true;
    },

    mudarDatas() {
      this.rendered = false;
      setTimeout(async () => {
        if (this.dates.range && this.dates.range.includes(" até ")) {
          const [start, end] = this.dates.range.split(" até ");
          this.dates.start = start;
          this.dates.end = end;
          localStorage.setItem(
            "dashboardDatas",
            JSON.stringify({
              start,
              end,
              restaurantes: this.restaurantesSelecionados,
            })
          );
          try {
            const token = localStorage.getItem("tokenAbitue");

            const response = await axios.post(
              "http://localhost:3001/api/cartoes/dashboard-resumo",
              {
                start: start,
                end: end,
                restaurantesSelecionados: this.restaurantesSelecionados, // 👈 aqui vai o array
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            this.dadosDashboard = response.data;
          } catch (err) {
            if (err.response && err.response.status === 403) {
              localStorage.removeItem("tokenAbitue");
              this.$router.push("/login");
            } else {
              console.error("Erro ao obter resumo do dashboard:", err);
            }
          }

          this.rendered = true;
        } else {
          console.log("no else", this.dates.range);
          this.rendered = true;
        }
      }, 500);
    },
    async carregarRestaurantes() {
      try {
        const token = localStorage.getItem("tokenAbitue");

        const response = await axios.get(
          "http://localhost:3001/api/restaurantes",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.restaurantes = response.data.map((rest) => ({
          value: rest.nome,
          label: rest.nome,
        }));
        console.log(this.restaurantes, "this.restaurantes");
      } catch (err) {
        if (err.response && err.response.status === 403) {
          localStorage.removeItem("tokenAbitue");
          this.$router.push("/login");
        } else {
          console.error("Erro ao carregar restaurantes:", err);
        }
      }
    },
    diferenca(actual, previous, tipo = "numero") {
      const diff = actual - previous;
      const sinal = diff > 0 ? "+" : diff < 0 ? "-" : "";

      if (tipo === "euro") {
        return sinal + this.formatarEuro(Math.abs(diff));
      } else {
        return sinal + this.formatarNumero(Math.abs(diff));
      }
    },
    formatarEuro(valor) {
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(valor);
    },
    formatarNumero(valor) {
      return new Intl.NumberFormat("pt-PT").format(valor);
    },
    classeDiferenca(a, b) {
      if (a > b) return "positive";
      if (a < b) return "negative";
      return "";
    },
  },
  async mounted() {
    await this.carregarRestaurantes();
    await this.inicio();
  },
};
</script>
<style>
.pink-solid .card {
  background: #ffe1d7;
}
.pink-transparent .card {
  background: #ffefea;
}
.positive {
  font-size: 25px;
  color: green;
}
.negative {
  font-size: 25px;
  color: red;
}
</style>
